import TodoList from "../todo-list"

export default class TodoProperties {

    public title        : string
    public completed    : boolean
    public messageId    : ID | null
    public userId       : ID | null

    constructor(rawData:any) {
        this.title      = _.get(rawData, 'title', '')
        this.completed  = _.get(rawData, 'completed', false)
        this.messageId  = _.get(rawData, 'messageId', null) // for item from message
        this.userId     = _.get(rawData, 'userId', null) // assigned userId
    }

    isCompleted = ()=> this.completed
    getName = () => this.title
    setName(value:string) {this.title = value}
    setStatus(value:boolean) {this.completed = value}
    setUser(value:ID) {this.userId = value}

    toJSON() {
        return {
            title       : this.title,
            completed   : this.completed,
            messageId   : this.messageId,
            userId      : this.userId,
        }
    }
}